import { filterNonNull } from "@msuite/utils/array";
import { moment } from "@msuite/utils/date";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "../../localization";
import { StatusTag } from "../../tag";
import { joinJSXElements } from "../../utils";
import { TableFooter } from "../table-footer";
import { useDataTableContext } from "./context";
import { DataTablePagination } from "./data-table-pagination";

export function DataTableFooter() {
	/** Hooks */
	const { queryKey, table, hasRowSelection } = useDataTableContext();
	const { t } = useTranslation();
	const qc = useQueryClient();

	/** Guard */
	if (!queryKey) return null;

	/** Computed */
	const dataUpdatedAt = qc.getQueryState(queryKey ?? [])?.dataUpdatedAt;
	const status = qc.getQueryState(queryKey ?? [])?.status;
	const lastUpdateAt = moment(dataUpdatedAt).longFormat();
	const pageSize = table.state.pagination.pageSize;
	const dataLength = table.getRowModel().rows.length;
	const filteredRowsLength = table.getPrePaginatedRowModel().rows.length;
	const hasFilter = dataLength !== filteredRowsLength;
	const labels = filterNonNull([
		`${dataLength} ${t("tables.total_items")}`,
		hasFilter ? `${filteredRowsLength} ${t("tables.filtered_items")}` : null,
		`${pageSize} ${t("tables.items_per_page")}`,
		`${t("general_fields.updated_at")}: ${lastUpdateAt}`,
		hasRowSelection
			? `${t("tables.n_items_selected", { count: table.getSelectedRowModel().rows.length.toString() })}`
			: null,
	]);

	/** Render */
	return (
		<TableFooter>
			<div className="gap-2 h-stack">
				<StatusTag status={status} />
				{status !== "error" && <p>{joinJSXElements(labels)}</p>}
			</div>
			<DataTablePagination />
		</TableFooter>
	);
}
